<button class="app-button__button app-text-first-letter-up">
  <ng-content></ng-content>
</button>
